import { createSlice } from "@reduxjs/toolkit";
import { getTermsAndConditionsDetailsAPI } from "../../services/getTermsAndConditionsDetails";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const getTermsAndConditionsDetailsSlice = createSlice({
  name: "getTermsAndConditionsDetails",
  initialState,
  reducers: {
    getTermsAndConditionsDetailsInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
      state.statusCode = undefined;
    },
    getTermsAndConditionsDetailsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = "";
      state.message = "";
      state.statusCode = undefined;
    },
    getTermsAndConditionsDetailsInfoFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = "";
      state.error = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    getTermsAndConditionsDetailsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const getTermsAndConditionsDetailsHandler =
  (payload, options = {}) =>
  async (dispatch) => {
    const requestOptions = { skipForbiddenRedirect: true, ...options };

    try {
      dispatch(
        getTermsAndConditionsDetailsAction.getTermsAndConditionsDetailsInfo(
          payload,
        ),
      );
      const response = await getTermsAndConditionsDetailsAPI(
        payload,
        requestOptions,
      );
      dispatch(
        getTermsAndConditionsDetailsAction.getTermsAndConditionsDetailsInfoSuccess(
          response,
        ),
      );
      return response;
    } catch (e) {
      const failurePayload =
        e && typeof e === "object" && "message" in e
          ? e
          : { message: e || "Something went wrong." };
      dispatch(
        getTermsAndConditionsDetailsAction.getTermsAndConditionsDetailsInfoFailure(
          failurePayload,
        ),
      );
    }
  };

export default getTermsAndConditionsDetailsSlice.reducer;
export const getTermsAndConditionsDetailsAction =
  getTermsAndConditionsDetailsSlice.actions;
